(() => {
  const drawer = document.getElementById('st-cart-drawer');
  if (!drawer) return;
  const root = drawer.dataset.root;
  const items = drawer.querySelector('[data-st-cart-items]');
  const status = drawer.querySelector('[data-st-cart-status]');
  const bottom = drawer.querySelector('[data-st-cart-bottom]');
  let cart, busy = false, opener, previousOverflow;
  const escape = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const money = amount => new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {style:'currency',currency:cart.currency || 'INR'}).format(amount / 100);
  const request = async (path, body) => {
    const response = await fetch(root + path, {method:body?'POST':'GET',headers:{Accept:'application/json',...(body?{'Content-Type':'application/json'}:{})},...(body?{body:JSON.stringify(body)}:{}),cache:'no-store'});
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'Your bag could not be updated. Please try again.');
    return data;
  };
  const setBusy = value => {
    busy = value;
    items.setAttribute('aria-busy', String(value));
    items.querySelectorAll('button').forEach(b => { b.disabled = value; });
    drawer.querySelector('.st-cart-checkout').setAttribute('aria-disabled', String(value));
  };
  function render() {
    drawer.querySelector('[data-st-cart-count]').textContent = cart.item_count;
    document.querySelectorAll('#cart-icon-bubble .cart-count-bubble span[aria-hidden=true]').forEach(e => {e.textContent=cart.item_count;});
    if (!cart.item_count) {
      items.innerHTML = `<div class="st-cart-empty"><span class="st-cart-empty-symbol" aria-hidden="true"><svg class="st-glyph" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="m12 2 3 7 7 3-7 3-3 7-3-7-7-3 7-3Z" fill="currentColor" stroke="none"/></svg></span><h3>A little room for joy.</h3><p>Your next favourite toy is waiting to be discovered.</p><a href="${escape(drawer.dataset.shopUrl)}">Explore all toys <svg class="st-glyph" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 19 19 5M5 5h14v14"/></svg></a></div>`;
      bottom.hidden = true;
      return;
    }
    items.innerHTML = cart.items.map(item => `<article class="st-cart-item" data-key="${escape(item.key)}">
      <a class="st-cart-picture" href="${escape(item.url)}" tabindex="-1" aria-hidden="true">${item.image?`<img src="${escape(item.image)}" alt="" width="172" height="172">`:''}</a>
      <div><h3><a href="${escape(item.url)}">${escape(item.product_title)}</a></h3>
      ${item.variant_title&&item.variant_title!=='Default Title'?`<p class="st-cart-variant">${escape(item.variant_title)}</p>`:''}
      ${Object.entries(item.properties||{}).filter(([key,value])=>value&&!key.startsWith('_')).map(([key,value])=>`<p class="st-cart-variant">${escape(key)}: ${escape(value)}</p>`).join('')}
      <p class="st-cart-price">${item.original_line_price>item.final_line_price?`<s>${money(item.original_line_price)}</s>`:''}${money(item.final_line_price)}</p>
      ${(item.line_level_discount_allocations||[]).map(d=>`<p class="st-cart-discount">${escape(d.discount_application.title)}</p>`).join('')}
      <div class="st-cart-controls"><div class="st-cart-quantity"><button type="button" data-quantity="${item.quantity-1}" aria-label="Decrease quantity of ${escape(item.product_title)}">−</button><span aria-label="Quantity">${item.quantity}</span><button type="button" data-quantity="${item.quantity+1}" aria-label="Increase quantity of ${escape(item.product_title)}">+</button></div><button type="button" class="st-cart-remove" data-quantity="0" aria-label="Remove ${escape(item.product_title)}">Remove</button></div></div></article>`).join('');
    drawer.querySelector('[data-st-cart-total]').textContent = money(cart.total_price);
    drawer.querySelector('[data-st-cart-tax]').textContent = (cart.taxes_included?'Taxes included. ':'')+'Shipping and discounts calculated at checkout.';
    bottom.hidden = false;
  }
  async function open(trigger) {
    if (busy) return;
    if (!drawer.open) {
      opener = trigger instanceof HTMLElement ? trigger : document.activeElement;
      previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      drawer.showModal();
    }
    status.textContent = 'Opening your toy bag…';
    setBusy(true);
    try {cart = await request('cart.js');render();status.textContent='';}
    catch(error) {status.textContent=error.message;}
    finally {setBusy(false);}
  }
  drawer.addEventListener('close', () => {document.body.style.overflow=previousOverflow || '';if(opener?.isConnected)opener.focus({preventScroll:true});});
  // drawer.addEventListener('click', async event => {
  //   if (busy && event.target.closest('.st-cart-checkout')) {event.preventDefault();return;}
  //   if(event.target.closest('[data-st-cart-close]')) {drawer.close();return;}
  //   if(event.target===drawer){const r=drawer.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)drawer.close();return;}
  //   const button = event.target.closest('[data-quantity]');
  //   if (!button || busy) return;
  //   const row=button.closest('[data-key]');const key=row.dataset.key;const quantity=Number(button.dataset.quantity);
  //   const focusIndex=[...items.querySelectorAll('[data-key]')].indexOf(row);const increase=button.textContent==='+';
  //   setBusy(true);status.textContent='Updating your toy bag…';
  //   try {cart=await request('cart/change.js',{id:key,quantity});render();status.textContent=quantity===0?'Toy removed from your bag.':'Quantity updated.';const next=items.querySelectorAll('[data-key]')[Math.min(focusIndex,cart.items.length-1)];(next?.querySelector(increase?'.st-cart-quantity button:last-child':'.st-cart-quantity button')||items.querySelector('a')||drawer.querySelector('[data-st-cart-close]')).focus();}
  //   catch(error){status.textContent=error.message;}
  //   finally{setBusy(false);}
  // });
  drawer.addEventListener('click', async event => {
  const checkoutButton = event.target.closest('.st-cart-checkout');

  if (checkoutButton) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (busy || checkoutButton.dataset.processing === 'true') return;

    checkoutButton.dataset.processing = 'true';
    checkoutButton.setAttribute('aria-disabled', 'true');

    drawer.querySelector('.st-cart-close')?.click();

    try {
      if (
        window.gokwikSdk &&
        typeof window.gokwikSdk.initCheckout === 'function'
      ) {
        window.gokwikSdk.initCheckout(merchantInfo);
      } else {
        throw new Error('GoKwik SDK is not ready.');
      }
    } catch (error) {
      console.error('GoKwik checkout error:', error);
      status.textContent = error.message || 'Unable to open checkout.';
    } finally {
      checkoutButton.dataset.processing = 'false';
      checkoutButton.setAttribute('aria-disabled', 'false');
    }

    return;
  }

  if (busy && event.target.closest('.st-cart-checkout')) {
    event.preventDefault();
    return;
  }

  if (event.target.closest('[data-st-cart-close]')) {
    drawer.close();
    return;
  }

  if (event.target === drawer) {
    const r = drawer.getBoundingClientRect();

    if (
      event.clientX < r.left ||
      event.clientX > r.right ||
      event.clientY < r.top ||
      event.clientY > r.bottom
    ) {
      drawer.close();
    }

    return;
  }

  const button = event.target.closest('[data-quantity]');
  if (!button || busy) return;

  const row = button.closest('[data-key]');
  const key = row.dataset.key;
  const quantity = Number(button.dataset.quantity);
  const focusIndex = [...items.querySelectorAll('[data-key]')].indexOf(row);
  const increase = button.textContent === '+';

  setBusy(true);
  status.textContent = 'Updating your toy bag…';

  try {
    cart = await request('cart/change.js', { id: key, quantity });
    render();

    status.textContent = quantity === 0
      ? 'Toy removed from your bag.'
      : 'Quantity updated.';

    const next = items.querySelectorAll('[data-key]')[
      Math.min(focusIndex, cart.items.length - 1)
    ];

    (
      next?.querySelector(
        increase
          ? '.st-cart-quantity button:last-child'
          : '.st-cart-quantity button'
      ) ||
      items.querySelector('a') ||
      drawer.querySelector('[data-st-cart-close]')
    ).focus();
  } catch (error) {
    status.textContent = error.message;
  } finally {
    setBusy(false);
  }
});
  document.addEventListener('click', event => {
    const link=event.target.closest('a[href]');
    if(!link||event.defaultPrevented||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey||link.target==='_blank')return;
    const url=new URL(link.href,location.origin);
    if(url.origin===location.origin&&url.pathname.replace(/\/$/,'')===drawer.dataset.cartUrl.replace(/\/$/,'')&&!url.search){event.preventDefault();event.stopImmediatePropagation();open(link);}
  },true);
  window.SashaktCart={open};
})();
